/* eslint-disable radix */
/* eslint-disable prefer-destructuring */
/* eslint-disable eqeqeq */
/* eslint-disable react/no-array-index-key */
/* eslint-disable array-callback-return */
/* eslint-disable arrow-body-style */
/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from "@material-ui/core/styles";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import MuiTableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import styles from './TableSimple.module.css';

const useStyles = makeStyles({
    table: {
       minWidth: "max-content",
        "& .MuiTableCell-root": {
            borderLeft: "1px solid rgba(224, 224, 224, 1)",

        },

    }
});

const TableSimple = ({ tableColumnData, tableHeaderLabel, TableRowHederAling,size,headerColor, selectAllChecked,
    handleSelectAllChange,checkedItems,handleCheckboxChange}) => {
    const classes = useStyles();
     // State for managing the "Select All" checkbox
//   const [selectAllChecked, setSelectAllChecked] = useState(false);

  // Function to handle the change of the "Select All" checkbox
//   const handleSelectAllChange = () => {
//     setSelectAllChecked(!selectAllChecked);
//     // Additional logic to update the state of individual checkboxes if needed
//   };

    const tableHeader = tableHeaderLabel?.map((label) => {
        const isSelectColumn = label === 'Select';

    if (isSelectColumn) {
      return (
        <TableCell key={`header-${label}`}width="5%" align={TableRowHederAling} className={styles.tableheaderFont}>
          
          <div>{label}</div>
          <div>
            <input
              type="checkbox"
              checked={selectAllChecked}
              onChange={handleSelectAllChange}
            />
          </div>
        </TableCell>
      );
    }

        if (typeof label !== 'string') {
            console.error('Label is not a string:', label);
            return null;  // Or handle this case appropriately
        }
    
        const myArray = label.split("_");
        
        let wd="auto";
        let labletext;
        if(myArray.length==2){
        wd=parseInt(myArray[1])
        labletext=myArray[0];

        } else {
             wd="auto";
             labletext=label;
        }

  return ( <TableCell key={label} width={wd} align={TableRowHederAling} className={styles.tableheaderFont}>{labletext}</TableCell>)

});
    const tableRow = tableColumnData?.map((row,id) => {
        return (<TableRow  key={`pratik${id}`} size={size} style={{overflowX:"visible"}}> 
            {Object.entries(row)?.map(([label, value], idx) => ( 
                <TableCell   align={TableRowHederAling}   className={styles.table_cell}>
                    {label === 'select' ? (
              <input
                type="checkbox"
                checked={(checkedItems ?? [])[id] || false}
                onChange={(event) => handleCheckboxChange(event, id)}
              />
            ) : (
              value
            )}
                </TableCell>
            ))
            }
        </TableRow>)
    });
    const TableHead = withStyles((theme) => ({
        root: {
            // position: "sticky",
            // top: '-2px',
            // zIndex: 1,  
            backgroundColor: headerColor,
            overflowX:"visible"
        }
    }))(MuiTableHead);
    // console.log(tableRow.length,"tableRow.length");
    return (
        <>
         <TableContainer
           style={{overflowX:"visible", width: "100%" }}
        
        >
            {/* <Table className={classes.table} size={tableRow.length>=2?size:size} aria-label="a dense table"> */}
            <Table className={classes.table} size={size} aria-label="a dense table">
                <TableHead>
                    <TableRow   style={{ width: 100 }}
>
                        {tableHeader}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {tableRow}
                </TableBody>
                           </Table>        
        </TableContainer>
         {/* <div style={{background:"blue",margin:"0px",padding:"0px",borderRadius:"5px",height:"10px",color:"blue",fontSize:"1px",overflowX:"10px"}}>
           t
         </div> */}
        </>
       
    );
};

TableSimple.propTypes = {
    tableColumnData: PropTypes.array,
    tableHeaderLabel: PropTypes.array,
    TableRowHederAling: PropTypes.string,
    size: PropTypes.string,
    headerColor: PropTypes.string,
    handleSelectAllChange:PropTypes.func,
    selectAllChecked:PropTypes.bool,
    checkedItems: PropTypes.array,
    handleCheckboxChange:PropTypes.func,

};

export default TableSimple;
